/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */



import React, { useState, useImperativeHandle, useEffect, useRef } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { Row, Col, Image, Space } from "antd";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import { PriceListTable } from './PriceListTable';
import usePrevious from "../../../../Shared/components/Previous";
import { NavLink } from "react-router-dom";
import { checkComponentPermission, capitalizeFirstLetter, exportCommonFile } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";


export const PriceList = React.forwardRef((props, ref) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { form, handleClose, handleSelectCustomer, view, handlePriceList, type, customObject } = props;
    const classes = customStyles();
    const dispatch = useDispatch();
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("updateTs");
    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('');
    const [apiGetList, setApiGetList] = useState([]);
    const [apiGetListAll, setApiGetListAll] = useState([]);

    const [topBar, setTopBar] = useState({});
    const prevSearch = usePrevious(search);
    const [selected, setSelected] = useState([]);
    const timeoutRef = useRef(null);
    const limit = 250;

    const dispatchFilter = (form, sortBy = 'updateTs', sortOrder = 'desc', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { "and": [{ isActive: true }] };
        let or = { ["or"]: [] };

        if (form?.fromDate) {
            filter['and'].push({ fromDate: { gte: moment(form?.fromDate).format('YYYY-MM-DD') } });
        }

        if (form?.toDate) {
            filter['and'].push({ toDate: { lte: moment(form?.toDate).format('YYYY-MM-DD') } });
        }

        if (form?.filterBy) {
            filter['and'].push({ customerSpec: form.filterBy });
        }

        if (form?.customerId) {
            filter['and'].push({ customerId: form.customerId });
        }

        if (form?.groupId) {
            filter['and'].push({ customerGroupId: form.groupId });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'salesPriceAgreement',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                // limit: limit,
                // skip: skip
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchSearchFilter(search, topBar);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchSearchFilter(search, topBar);
                }, 500);
            }
        }
    }, [search]);

    const dispatchSearchFilter = (search, topBar) => {
        let a = apiGetListAll;

        if (search !== '') {
            a = apiGetListAll?.filter((el) => {
                return (el?.product?.productName?.match(new RegExp(search, "i")) ||
                    el?.product?.universalproduct?.productId?.match(new RegExp(search, "i")) ||
                    el?.unit?.name?.match(new RegExp(search, "i")))
            });
        }

        if (topBar?.productId) {
            a = a?.filter((el) => {
                return (el?.productId === topBar?.productId)
            });
        }

        if (topBar?.fromDate || topBar?.toDate) {
            if (topBar?.fromDate && topBar?.toDate) {
                a = a?.filter((el) => {
                    return (el?.fromDate >= moment(topBar?.fromDate).format('YYYY-MM-DD') &&
                        el?.toDate <= moment(topBar?.toDate).format('YYYY-MM-DD'))
                });
            } else if (topBar?.fromDate) {
                a = a?.filter((el) => {
                    return (el?.fromDate >= moment(topBar?.fromDate).format('YYYY-MM-DD'))
                });
            } else if (topBar?.toDate) {
                a = a?.filter((el) => {
                    return (el?.toDate <= moment(topBar?.toDate).format('YYYY-MM-DD'))
                });
            }
        }
        
        if (topBar?.updateTs) {
            const topBarDate = moment(topBar.updateTs);
            a = a?.filter((el) => {
                return moment(el?.updateTs).isSame(topBarDate, 'day');
            });
        }
        setApiGetList(a);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(form, sortBy, sortOrder);
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter(form) {
            dispatchFilter(form);
        }
    }));

    useEffect(() => {
        if (view === 'price' && getList) {
            setApiGetList(form?.productFilter === 'catalogue' ?
                getList?.filter((el) => el?.product?.universalProductId !== null) :
                getList?.filter((el) => el?.product?.universalProductId === null));
            setApiGetListAll(form?.productFilter === 'catalogue' ?
                getList?.filter((el) => el?.product?.universalProductId !== null) :
                getList?.filter((el) => el?.product?.universalProductId === null));
        }
    }, [getList]);


    useEffect(() => {
    }, [form]);


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(form, sortBy, sortOrder, s);
    }

    const handleSelectedPriceList = () => {
        handlePriceList(apiGetList.filter((el) => { return selected.find(e => e === el.id) }));
        handleSelectCustomer();
    }
    const [picker, setPicker] = useState(false);


    const handleDate = (value, name) => {
        let data = {
            ...topBar,
            [name]: value
        };
        setTopBar(data);
        dispatchSearchFilter(search, data);
    }

    const handlePicker = () => {
        setPicker(!picker);
        let data = {
            ...topBar,
            fromDate: '',
            toDate: ''
        };
        setTopBar(data);
        dispatchSearchFilter(search, data);
    }

    const handleProductChange = (id) => {
        let data = {
            ...topBar,
            productId: id
        };
        setTopBar(data);
        dispatchSearchFilter(search, data);
    }

    const handleUpdatedDate = (value, name) => {
        let data = {
            ...topBar,
            [name]: value
        };
        setTopBar(data);
        dispatchSearchFilter(search, data);
    }


    return <>
        <MainHeader {...props} img={SettingsImg} handleCloseClick={() => handleClose('batch')}
            title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Batch Process', 'link': '' }]} />
        <div className={clsx(classes.margin40, classes.listTableMargin)}>
            <PrimaryCard
                title={'Price List'}
                component={
                    <>
                        <Row align="middle" className={classes.marginBottom20}>
                            <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                {
                                    roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Action', 'Product Search') &&
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image
                                            src={SearchIcon}
                                            preview={false}
                                        />
                                    </div>
                                }
                            </Col>

                            <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.allCustomerTop)}>
                                <div className={classes.overlFlowResponsiveDesign}>
                                    <Space direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Page', 'Product Search') &&
                                            <AutoCompleteComponent
                                                customLabel={"All Product"}
                                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                                { 'key': 'productId', 'name': 'Product ID' }]}
                                                details={myProductdetails}
                                                parentValue={customObject(myProductdetails, topBar?.productId)}
                                                position={"bottom"}
                                                customClasses={classes.customWidth172P}
                                                variant={'outlined'}
                                                onChangeText={(data) => {
                                                    if (data === '') {
                                                        handleProductChange();
                                                    }
                                                }}
                                                onChange={(data) => {
                                                    handleProductChange(data.id);
                                                }}
                                            />
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Page', 'Date Filter') &&
                                            <>
                                                <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                    <Row>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <NavLink to='#' onClick={() => handlePicker()}
                                                                className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder,
                                                                    classes.dropDownWidth, classes.margint0, classes.dropDownPointer)} >
                                                                Date Filter
                                                                <Image src={DropDown} preview={false} />
                                                            </NavLink>
                                                        </Col>
                                                        {
                                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            label="From Date"
                                                                            //value={form?.fromDate}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                },
                                                                            }}
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError) {
                                                                                    handleDate('', 'fromDate');
                                                                                } else {
                                                                                    handleDate(newValue, 'fromDate');
                                                                                }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            minDate={new Date(form?.fromDate)}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            label="To Date"
                                                                            // value={form?.toDate}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                },
                                                                            }}
                                                                            onChange={(newValue, newError) => {
                                                                                if (newError?.validationError) {
                                                                                    handleDate('', 'toDate')
                                                                                } else {
                                                                                    handleDate(newValue, 'toDate')
                                                                                }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            </>
                                        }
                                        <div className={clsx(classes.dateFilterdateAdjustUpdated)}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    slots={{
                                                        openPickerIcon: DateIcon
                                                    }}
                                                    views={['year', 'month', 'day']}
                                                    allowKeyboardControl={false}
                                                    label="Updated Date"
                                                    //value={form?.fromDate}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        },
                                                    }}
                                                    onChange={(newValue, newError) => {

                                                        if (newError?.validationError) {
                                                            handleUpdatedDate('', 'updateTs');
                                                        } else {
                                                            handleUpdatedDate(newValue, 'updateTs');
                                                        }
                                                    }}
                                                    format="dd/MM/yyyy"
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        {
                                            apiGetList && apiGetList.length > 0 && <NavLink
                                                to={'#'}
                                                onClick={() => exportCommonFile('Price List', selected && selected?.length > 0 ? apiGetList.filter((el) => selected.includes(el.id)) : apiGetList, 'existing', [])}
                                                className={clsx(classes.AddMoreBtn, classes.mr10)}>
                                                Export
                                            </NavLink>
                                        }
                                        <NavLink
                                            to={'#'}
                                            onClick={() => handleClose('batch')}
                                            className={clsx(classes.AddMoreBtn)}>
                                            Cancel
                                        </NavLink>
                                        {/* {
                                            selected && selected?.length > 0 &&
                                            <>
                                                {
                                                    form?.productFilter === 'catalogue' ? <>
                                                        {
                                                            getList && getList?.filter((el) => el?.product?.universalProductId !== null).length > 0 && <NavLink
                                                                to={'#'}
                                                                onClick={() => handleSelectedPriceList()}
                                                                className={clsx(classes.modalBtn, { [classes.disabled]: getList.length === 0 })}>
                                                                Select Customer
                                                            </NavLink>
                                                        }
                                                    </> : <>
                                                        {
                                                            getList && getList?.filter((el) => el?.product?.universalProductId === null).length > 0 && <NavLink
                                                                to={'#'}
                                                                color='primary'
                                                                variant="contained"
                                                                onClick={() => handleSelectedPriceList()}
                                                                className={clsx(classes.modalBtn, { [classes.disabled]: getList.length === 0 })}>
                                                                Select Customer
                                                            </NavLink>
                                                        }
                                                    </>
                                                }
                                            </>
                                        } */}
                                        {
                                            selected && selected?.length > 0 && <NavLink
                                                to={'#'}
                                                onClick={() => handleSelectedPriceList()}
                                                className={clsx(classes.modalBtn)}>
                                                Select Customer
                                            </NavLink>
                                        }
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                        <PriceListTable
                            {...props}
                            selected={selected}
                            loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                            details={apiGetList}
                            loadMore={loadMore}
                            loadMoreTask={() => loadMoreTask()}
                            loadMoreContent={loadMoreContent}
                            sortOrder={sortOrder}
                            sortBy={sortBy}
                            handleSelected={(value) => setSelected(value)}
                            roleManagement={roleManagement}
                            onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        />
                    </>
                }
            />
        </div>
    </>
})